import {
  Breadcrumbs,
  Button,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Link,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import SpeakerPhoneIcon from "@material-ui/icons/SpeakerPhone";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import SortableTable from "../../../Components/SortableTable";
import StockItemSearch from "../../../Components/StockItems/StockItemSearch";
import Title from "../../../Components/Title";
import { showPopupSnackbar } from "../../../redux/actions/snackbarActions";
import {
  formatGoogleDriveMediaLink,
  getToken,
  getWarehouses,
  requestErrorHandler,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
import { useStyles } from "../../../Utils/Styles";
import QRScannerView from "../QRScannerView";

const server = EnvSettings.server;

export default function ModifyStock() {
  const classes = useStyles();
  const [editedValues, setEditedValues] = useState();
  const [item, setItem] = useState();
  const [scan, setScan] = useState(false);
  const [warehouseLocation, setWarehouseLocation] = useState();
  const [warehouse, setWarehouse] = useState();
  const [changesList, setChangesList] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [scannedCode, setScannedCode] = useState("");
  const [radio, setRadio] = useState();

  const clearValues = () => {
    setItem();
    setScan(false);
    setEditedValues();
    setScannedCode("");
  };

  const [key, setKey] = useState("asdfdsfsad");

  const handleRadioChange = (e) => {
    var val = e.target.value;
    setEditedValues(undefined);
    setRadio(val);
    setKey(Date.now());
    if (val !== "other") {
      setTimeout(() => {
        setEditedValues({ reason: val });
      }, 100);
    }
  };

  const addStockQuantity = (data, stock) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        stock_item: data,
      }),
    };
    fetch(server + "/add_stock_quantity", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          dispatch(showPopupSnackbar({ error: false, message: "Success" }));
          var obj = {
            ...data,
            old_value: stock.total,
            change: Number(data.total) - Number(stock.total),
            list_id: (changesList ? changesList.length : 0) + 1,
          };
          setChangesList(changesList ? [...changesList, obj] : [obj]);
          clearValues();
        }
        // setLoading(false);
      });
  };

  useEffect(() => {
    const getStockItems = () => {
      // setLoadingStockItems(true);
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
          search_column: "scannerCode",
          search_value: scannedCode,
          warehouse: warehouse,
        }),
      };
      fetch(server + "/get_stock_quantity", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          requestErrorHandler(result, dispatch);
          if (!result.error) {
            if (result.stock) {
              setItem(result.stock);
            }
          }
          // setLoadingStockItems(false);
        });
    };
    if (scannedCode && warehouse) {
      getStockItems();
    }
  }, [scannedCode, warehouse, dispatch]);

  useEffect(() => {
    getWarehouses(setWarehouseLocation, dispatch);
  }, [dispatch]);

  return warehouseLocation ? (
    <Grid container spacing={3}>
      <Dialog open={scan}>
        <DialogContent>
          <QRScannerView
            show={scan}
            exit={() => {
              setScan(false);
            }}
            setValue={setScannedCode}
          ></QRScannerView>
        </DialogContent>
      </Dialog>
      <Grid item xs={12}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/cpanel/stock">
            {t("stock.header")}
          </Link>
          <Typography>{t("stockModule.modifyStock")}</Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          {!(item && warehouse) ? (
            <Grid
              container
              spacing={1}
              direction="row"
              item
              xs={6}
              justify="space-evenly"
            >
              <Grid item xs={12}>
                <Typography>{t("stockModule.warehouse")}</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label={t("stockModule.warehouse")}
                  value={warehouse}
                  onChange={(e, v) => {
                    if (!e || !e.target.value) {
                      return;
                    }
                    setWarehouse(e.target.value);
                  }}
                  select
                >
                  {warehouseLocation
                    .filter((a) => a.editableStock)
                    .map((m, i) => (
                      <MenuItem key={m.value + i} value={m.value}>
                        {m.label}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              {/* Scan or search for item */}
              {warehouse ? (
                <>
                  <Grid item xs={12}>
                    <Typography>{t("emailLists.searchStockItem")}</Typography>
                  </Grid>

                  <Grid item xs={3}>
                    <Typography>{scannedCode}</Typography>
                    <Grid item>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setScan(true);
                        }}
                        endIcon={<SpeakerPhoneIcon />}
                      >
                        {t("scanCode")}
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography>{t("or")}</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <StockItemSearch
                      allowNewItems={false}
                      includeQuantity={true}
                      onChange={(e, v) => {
                        if (!v) {
                          return;
                        }
                        var q = {};
                        if (v && v.StockQuantities) {
                          q = v.StockQuantities.find(
                            (qq) => qq.Warehouse.name === warehouse
                          );
                        }
                        q = { ...q, StockItem: v };
                        setItem(q);
                      }}
                    />
                  </Grid>
                </>
              ) : null}
            </Grid>
          ) : null}
          {item && warehouse ? (
            <Grid
              container
              spacing={1}
              direction="row"
              item
              xs={12}
              justify="space-evenly"
            >
              <Grid item xs={12} sm={3} style={{ minHeight: 350 }}>
                {/* {item?.imageUrl || item?.StockItem?.imageUrl ? ( */}
                <>
                  <img
                    alt={(item.StockItem?.name || item?.name) + "-image"}
                    src={formatGoogleDriveMediaLink(
                      item?.StockItem?.imageUrl || item?.imageUrl
                    )}
                    style={{ width: 200 }}
                  />
                </>
                {/* ) : null} */}
              </Grid>
              <Grid container item xs={12} sm={9} spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={t("stockModule.warehouse")}
                    variant="outlined"
                    value={
                      warehouseLocation.find((f) => f.value === warehouse).label
                    }
                    disabled
                  ></TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    disabled
                    label={"SKU"}
                    value={item?.StockItem?.sku || item?.sku}
                  ></TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    disabled
                    label={t("stockModule.name")}
                    value={item?.StockItem?.name || item.name}
                  ></TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    disabled
                    label={t("stockModule.total")}
                    value={item?.StockItem?.total || item.total}
                  ></TextField>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      {t("stockModule.stockModificationReason")}
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-label="position"
                      name="position"
                      onChange={handleRadioChange}
                    >
                      {["dispatch", "resupply", "other"].map((q) => (
                        <FormControlLabel
                          key={q}
                          value={q}
                          control={<Radio color="primary" />}
                          label={t(q)}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </Grid>
                {radio && radio === "dispatch" ? (
                  <Grid item xs={12}>
                    <TextField
                      key={key}
                      fullWidth
                      variant="outlined"
                      type="number"
                      label={t("stockModule.dispatchedAmount")}
                      inputProps={{ min: 0 }}
                      onChange={(e, v) => {
                        if (!e || !e.target || !e.target.value) {
                          return;
                        }
                        var q = item.total - Number(e.target.value);
                        setEditedValues({
                          ...editedValues,
                          total: q,
                          free: q,
                        });
                      }}
                    ></TextField>
                  </Grid>
                ) : radio && radio === "resupply" ? (
                  <Grid item xs={12}>
                    <TextField
                      key={key}
                      fullWidth
                      variant="outlined"
                      type="number"
                      label={t("stockModule.receivedAmount")}
                      inputProps={{ min: 0 }}
                      onChange={(e, v) => {
                        if (!e || !e.target || !e.target.value) {
                          return;
                        }
                        var q = item.total + Number(e.target.value);
                        setEditedValues({
                          ...editedValues,
                          total: q,
                          free: q,
                        });
                      }}
                    ></TextField>
                  </Grid>
                ) : radio ? (
                  <Grid item xs={12}>
                    <TextField
                      key={key}
                      fullWidth
                      variant="outlined"
                      type="number"
                      label={t("newValue")}
                      inputProps={{ min: 0 }}
                      defaultValue={item.total}
                      onChange={(e, v) => {
                        setEditedValues({
                          ...editedValues,
                          total: e.target.value,
                          free: e.target.value,
                        });
                      }}
                    ></TextField>
                  </Grid>
                ) : null}
                {radio && radio === "other" ? (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label={t("stockModule.stockModificationReason")}
                      onChange={(e, v) => {
                        setEditedValues({
                          ...editedValues,
                          reason: e.target.value,
                        });
                      }}
                    ></TextField>
                  </Grid>
                ) : null}
                {editedValues && !isNaN(editedValues.total) ? (
                  <Grid item container sm={6} xs={12}>
                    <Grid item xs={4}>
                      <Typography>{t("oldValue")}</Typography>
                    </Grid>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={4}>
                      <Typography>{t("newValue")}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography>{item.total}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography>{"-->"}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography>{editedValues?.total}</Typography>
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
              <Grid item container xs={12}>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      addStockQuantity({ ...item, ...editedValues }, item);
                    }}
                  >
                    {t("submit")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={clearValues}
                  >
                    {t("cancel")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          ) : null}
        </Paper>
      </Grid>
      {changesList ? (
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Grid item xs={12}>
              <Title>{t("stockModule.listOfChanges")}</Title>
              <SortableTable
                header={"Stock Changes"}
                tableLayout={"fixed"}
                defaultSortRow={"list_id"}
                downloadButton={true}
                tableData={changesList}
                getRowStyle={(v, index) => {
                  var obj = { cursor: "pointer" };
                  if (index % 2 === 0) {
                    obj.backgroundColor = "rgb(245,245,245)";
                  }
                  return obj;
                }}
                headCells={[
                  {
                    id: "list_id",
                    label: "#",
                  },
                  {
                    id: "StockItem.sku",
                    label: t("stockModule.sku"),
                  },
                  {
                    id: "old_value",
                    label: t("oldValue"),
                  },
                  {
                    id: "total",
                    label: t("newValue"),
                  },
                  {
                    id: "change",
                    label: t("difference"),
                  },
                  {
                    id: "reason",
                    label: t("stockModule.stockModificationReason"),
                  },
                  {
                    id: "Warehouse.name",
                    label: t("stockModule.warehouse"),
                  },
                ]}
                specialDataFormatting={[
                  {
                    id: "Warehouse.name",
                    format: (data) => {
                      return warehouseLocation.find((f) => f.value === data)
                        .label;
                    },
                  },
                  {
                    id: "change",
                    format: (data) => {
                      return data > 0 ? "+" + data : data;
                    },
                  },
                ]}
              ></SortableTable>
            </Grid>
          </Paper>
        </Grid>
      ) : null}
    </Grid>
  ) : null;
}
